import { render } from "./TextDropDownMenuItem.vue?vue&type=template&id=6e56c3e0"
import script from "./TextDropDownMenuItem.vue?vue&type=script&lang=js"
export * from "./TextDropDownMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__